import React from "react";
import "../Loading.css";

export const OverlayLoader = () => {
    return (
        <div className='loading-screen'>
            <div className='inner-loader'>
                <div className="spinner"></div>
            </div>
        </div>
    )
}